export default __webpack_public_path__ + "static/media/sauced_oven_white.c6032794.png";